/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:13/02/2021
 @Time:08:50
 **/
import PaiementLigneBase from "./PaiementLigneBase";

export default class PaiementLigneCheque extends PaiementLigneBase{

    /**
     * Le numéro de chèque
     * @var{number}
     */
    #_numeroCheque;




    constructor(numeroCheque) {
        super();
        this.#_numeroCheque = numeroCheque;
        this.discriminator="cheque";
    }

    get numeroCheque() {
        return this.#_numeroCheque;
    }

    set numeroCheque(value) {
        this.#_numeroCheque = value;
    }

    static createFromJson(paiementLigneJson,paiementLigneBase){
        let paiementLigneCheque=new PaiementLigneCheque();
        super.createFromJson(paiementLigneJson,paiementLigneCheque);
        paiementLigneJson.numeroCheque||(paiementLigneCheque.numeroCheque=paiementLigneJson.numeroCheque);
        return paiementLigneCheque;
    }
}